"use client";

import { Box, Container, Divider, Grid2, Typography } from "@repo/ui";
import Link from "next/link";
import Image from "next/image";

const OrderFooter = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer>
      <Box className="bg-primary-dark text-slate-100 py-[1.25rem]">
        <Container className="flex  items-center justify-between flex-col md:flex-row gap-4">
          <div>
            <Image
              src="/images/white-logo.webp"
              width={100}
              height={64}
              className="w-auto"
              alt="white-log"
            />
          </div>
          <Grid2 container spacing={3} justify="between" className="flex-1">
            <Grid2 size={{ xs: 12, sm: 6, md: 7, lg: 7 }}>
              <Box flex className="gap-2 flex-col md:flex-row  pt-1">
                <Typography
                  render={
                    <Link
                      href="/terms-and-conditions/"
                      rel="noopener noreferrer"
                    />
                  }
                  variant="body1"
                >
                  Terms and conditions
                </Typography>
                <Divider orientation="vertical" />
                <Typography
                  variant="body1"
                  render={
                    <Link href="/privacy-policy/" rel="noopener noreferrer" />
                  }
                >
                  Privacy policy
                </Typography>
                <Divider orientation="vertical" />
                <Typography
                  variant="body1"
                  render={
                    <Link href="/refund-policy/" rel="noopener noreferrer" />
                  }
                >
                  Refund policy
                </Typography>
                <Divider orientation="vertical" />
                <Typography
                  variant="body1"
                  render={
                    <Link
                      href="/rescheduling-policy"
                      rel="noopener noreferrer"
                    />
                  }
                >
                  Reschedule policy
                </Typography>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 5, lg: 5 }}>
              <Box className="sm:text-right pt-1 text-left">
                <Typography variant="body1">
                  © 2020 - {currentYear} | All Rights Reserved
                </Typography>
              </Box>
            </Grid2>
          </Grid2>
        </Container>
      </Box>
    </footer>
  );
};

export default OrderFooter;
